export default "__VITE_ASSET__abd383e0__"